import React, {useEffect, useRef} from "react";

import HeroImage from "../../../assets/img/hero-img.svg"

import './hero-section.styles.scss'

const HeroSection = () => {
    const sectionRef = useRef(null);
    useEffect(()=>{
        setTimeout(()=>{
            if(sectionRef?.current){
                sectionRef.current.classList.add("play")
            }
        }, 300)

    },[])
    return (
        <section ref={sectionRef} className="hero-section container flex flex-col justify-center md:justify-start md:pt-[20vh] items-center h-screen">
            <img src={HeroImage} alt="Η ΔΕΗ συναντά την τέχνη" className="max-h-[60vh] mb-6 md:mb-8 transition delay-300 duration-700"/>
            <h2 className="font-bold text-2xl pb-3"> 32 έργα σε μια μεγάλη έκθεση </h2>
            <p className="text-base text-center max-w-[730px] pb-6">
                Με επιτυχία ολοκληρώθηκε η Έκθεση με τα 32 έργα που προκρίθηκαν στην τελική φάση του διαγωνισμού «Η ΔΕΗ ΣΥΝΑΝΤΑ ΤΗΝ ΤΕΧΝΗ» και φιλοξενήθηκε στο Ιστορικό Εργοστάσιο της ΔΕΗ στο Νέο Φάληρο.
            </p>
        </section>
    )
}

export default HeroSection
